import superagentRequest from 'superagent';
import Methods from './Methods';
import RequestController from './RequestController';
/**
 * @param requestObject Request
 * @return {Promise<any> | Promise}
 */
export default (function (requestObject) { return new Promise(function (resolve, reject) {
    var url = requestObject.ignorePrefix ? requestObject.url : window.apiHost + window.apiPrefix + requestObject.url;
    var apiCall = superagentRequest(requestObject.method, url);
    apiCall.set('Accept', 'application/json');
    // Store request object
    requestObject.setRequest(apiCall);
    // Apply timeout
    if (!requestObject.ignoreResponseTimeout) {
        apiCall.timeout({
            response: 120000,
            deadline: 120000 // and allow 120 seconds for the request to finish.
        });
    }
    // Add to blocking queue
    if (requestObject.blockUI) {
        RequestController.addRequest(requestObject);
    }
    // Set optional headers
    if (requestObject.headers) {
        for (var key in requestObject.headers) {
            if (requestObject.headers.hasOwnProperty(key)) {
                apiCall.set(key, requestObject.headers[key]);
                if (key === 'Accept' && requestObject.headers[key] === 'application/pdf') {
                    apiCall.responseType = 'blob';
                }
            }
        }
    }
    // Use credentials
    if (requestObject.withCredentials) {
        apiCall.withCredentials();
    }
    // Add data and do request
    if (requestObject.data) {
        requestObject.method === Methods.GET ? apiCall.query(requestObject.data) : apiCall.send(requestObject.data);
    }
    // Handle result or error
    apiCall.end(function (error, result) {
        // remove from blocking queue
        if (requestObject.blockUI) {
            RequestController.removeRequest(requestObject);
        }
        // handle response
        if (error) {
            reject({ error: error, response: result });
        }
        else {
            resolve(result.body ? result.body : result.text);
        }
    });
}); });
